import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/administration/_administration/local-accounts/_local-accounts')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.localAccounts' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
